import { DatePickerPlayground } from "../DatePickerPlayground";
import { DateRangeFilterPlayground } from "../DateRangeFilterPlayground";
import { TimePickerPlayground } from "../TimePickerPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const dateTimeEntries: PlaygroundComponentEntry[] = [
    {
        id: "date-picker",
        label: "Date picker",
        description:
            "Single dates, ranges, and full weeks with adaptable trigger and embedded layouts.",
        group: "components",
        render: () => <DatePickerPlayground />,
    },
    {
        id: "time-picker",
        label: "Time picker",
        description:
            "Duration estimates with preset grid, free-form input, and customizable trigger.",
        group: "components",
        render: () => <TimePickerPlayground />,
    },
    {
        id: "date-range-filter",
        label: "Date range filter",
        description: "Date range picker with presets.",
        group: "components",
        render: () => <DateRangeFilterPlayground />,
    },
];
